// 9fbef606107a605d69c0edbcd8029e5d
import { connect } from 'react-redux';
import { compose } from 'redux';
import NavigateXHRSelector from '@tcp/core/src/components/features/account/NavigateXHR/container/NavigateXHR.selectors';
import {
  getDynamicShippingCharge,
  getIsBossEnabled,
  getIsCrossBrandMerchandisingEnabled,
  getIsDynamicFreeShippingEnabled,
} from '../../../../../../../reduxStore/selectors/session.selectors';
import BossUnavailableGroupView from '../views/BossUnavailableGroup.view';
import {
  getBossUnavailableList,
  moveItemsToBossUnavailableList,
  removeItemsToBossUnavailableList,
  resetBossUnavailableState,
} from './BossUnavailable.actions';
import { getBossUnavailableListId, getBossUnavailableProduct } from './BossUnavailable.selector';
import { getCurrencyAttributesAsArray } from '../../../../../../../reduxStore/selectors/currency.selectors';
import { getUserLoggedInState } from '../../../../../account/User/container/User.selectors';
import { getFreeShippingThresholdValue } from '../../../../BagPage/container/BagPage.selectors';

const mapStateToProps = (state) => {
  return {
    bossUnavailableProducts: getBossUnavailableProduct(state),
    isCrossBrandMerchandisingEnabled: getIsCrossBrandMerchandisingEnabled(state),
    cookieToken: NavigateXHRSelector.getCookieToken(state),
    currencyExchange: getCurrencyAttributesAsArray(state),
    bossUnavailableListId: getBossUnavailableListId(state),
    isUserLoggedIn: getUserLoggedInState(state),
    isDynamicFreeShippingEnabled: getIsDynamicFreeShippingEnabled(state),
    freeShippingThreshold: getFreeShippingThresholdValue(state),
    dynamicShippingCharge: getDynamicShippingCharge(state),
    isBossEnabled: getIsBossEnabled(state),
  };
};
export const mapDispatchToProps = (dispatch) => {
  return {
    moveItemsToBossUnavailableListAction: (payload) =>
      dispatch(moveItemsToBossUnavailableList(payload)),
    removeItemsToBossUnavailableItemAction: (payload) =>
      dispatch(removeItemsToBossUnavailableList(payload)),
    getBossUnavailableListAction: () => dispatch(getBossUnavailableList()),
    resetBossUnavailableStateAction: () => dispatch(resetBossUnavailableState()),
  };
};
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(BossUnavailableGroupView);
